const BETA_INTEGRATION_SLUGS = new Set<string>([
  // Add integration slugs here to mark them as beta.
  'decathlon',
  'superdrug',
  'mountainwarehouse',
  'freemans',
  'argos'
]);

export const IsBetaIntegration = (integrationSlug?: string | null): boolean => {
  if (!integrationSlug) {
    return false;
  }

  return BETA_INTEGRATION_SLUGS.has(integrationSlug.trim().toLowerCase());
};
